import { IDashboardMetadata, IRowCountCtx } from '../dashboard-metadata.service';
import {
  LARGE_QUOTE_KPI,
  SAT_TICKET_COLUMNS,
  TICKET_SORT,
  uniqueCountIndicator,
  USER_APPROVAL_COLUMNS,
  VIP_COLUMNS
} from './shared-dashboard.config';
import { IReportData } from '../../../../shared/report/report-data.service';
import { OdDashboardFiltersComponent } from '../filters/od/od-dashboard-filters.component';
import { DateType } from '../../../../shared/services/date.util';


export const OD_OD_DASHBOARD_CONFIG:IDashboardMetadata = {
  title: 'PSS KPI',
  filterComponent: {
    name: OdDashboardFiltersComponent,
    inputs: {
      allowSearchWithoutFilters: true,
      showDIYFilter: false
    }
  },
  mapping: {
    Odlname: 'pss.id',
    Decurce: 'currency.id',
    Devincl: 'vatIncl.id',
    Pacgrid: 'bpGroup.id',
    Oddesk: 'bpDesk'
  },
  extraMapping: {
    Pacomnm: 'bp.companyCountryId'
  },
  fixedFilters: {
    Decurce: 'EUR',
    Devincl: '0'
  },
  reports: [
    {
      id: 210,
      key: 'INVOICE_TO_APPROVE',
      fixedFilters: {
        Deinvcr_ds: 'F',
        Deinvst_ds: '@NEW@@SEND@',
        // Deinvdt_FROM: 'sysdate-60',
        Deinvty_ds: 'CENTRAL',
        Deiacsl: 'is null',
        Dedocok_inv: 1
      },
      mapping: {
        Pacomnm: 'bp.companyCountryId'
      },
      columns: [
        'Dereqid', //ACSL#
        'Dereqst', //Main Status
        'Dedownl_inv', //Invoice
        'Iatotal', //Invoice total ACSL
        'Ivtotal', //Invoice total BP
        'Iapayto', //Payment total BP
        'Decounm', //Country
        'Desprnm', //Webshop
        'Pacomnm', //BP
        'Dedownl_pod', //POD
        'Detrckc_comment', //Tracking
        'Desernr', //Serial numbers
        'Odlname', //OD
        'Gblname' //GBDM
      ]

    },

    {
      id: 219,
      key: 'DUE_INVOICES',
      mapping: {
        Pacomnm: 'bp.companyCountryId'
      },
      fixedFilters: {
        Decovst_ds: 'Operational issues'
      },
      restricted: true
    },

    {
      id: 221,
      key: 'VIP_ORDERS',
      columns: VIP_COLUMNS,
      mapping: {
        Pacomnm: 'bp.companyCountryId'
      },
      fixedFilters: {
        Devipnr: 'VIP'
      }
    },

    {
      browselistCode: 'TICKET',
      key: 'SAT_TICKETS',
      mapping: {
        Deccoid: 'bp.companyCountryId',
        Odlname: 'pss.id',
        Pacgrid: 'bpGroup.id'
      },
      fixedFilters: {
        Demntty: '@SAT@'
      },
      columns: SAT_TICKET_COLUMNS,
      sort: TICKET_SORT
    },

    {
      id: 272,
      key: 'MISSING_NAMS',
      fixedFilters: {
        Nam_present_value: 1
      },
      mapping: {
        Bp: 'bp.companyCountryId',
        Bp_group: 'bpGroup.id',
        Od_name: 'pss.id'
      },
      columns: [
        'Webshop', //Webshop
        'Country',
        'Role_description',
        'Bp', //BP
        'Bp_group',
        'Main_oem', //OEM
        'Lam_details',//LAM
        'Od_name',
        'Oddesk'
      ]
    },

    {
      id: 257,
      key: 'USERS_TO_APPROVE',
      comments: 'Users that belong to an active BP',
      fixedFilters: {
        Decrety_ds: 'SIGNUP',
        Destate_ds: 'WAIT_APRVL',
        Decredt_FROM: '01/01/2018',
        Kpi: 'ACTIVE_BPUSERS',
        Dashboard: 'OD'
      },
      mapping: {
        Decomnm: 'bp.company.id',
        Decounm: 'bp.country.id',
        Decgrid: 'bpGroup.id'
      },
      columns: USER_APPROVAL_COLUMNS
    },

    {
      id: 232,
      key: 'OPEN_ITEMS_FULLY_AUTONOMOUS',
      mapping: {
        Pacomnm: 'bp.companyCountryId'
      },
      fixedFilters: {
        Decovst_ds: 'FULL'
      },
      restricted: true
    },

    {
      id: 232,
      key: 'OPEN_ITEMS_SEMI_AUTONOMOUS',
      mapping: {
        Pacomnm: 'bp.companyCountryId'
      },
      fixedFilters: {
        Decovst_ds: 'SEMI'
      },
      restricted: true
    },

    {
      id: 232,
      key: 'OPEN_ITEMS_TRAINING',
      mapping: {
        Pacomnm: 'bp.companyCountryId'
      },
      fixedFilters: {
        Decovst_ds: 'TRAINING'
      },
      restricted: true
    },

    {
      id: 232,
      key: 'OPEN_ITEMS_FULLY_ISSUES',
      mapping: {
        Pacomnm: 'bp.companyCountryId'
      },
      fixedFilters: {
        Decovst_ds: 'ISSUES'
      },
      restricted: true
    },

    {
      id: 232,
      key: 'OPEN_ITEMS_INACTIVE',
      mapping: {
        Pacomnm: 'bp.companyCountryId'
      },
      fixedFilters: {
        Decovst_ds: 'INACTIVE'
      },
      restricted: true
    },

    {
      id: 232,
      key: 'OPEN_ITEMS_VIRTUAL',
      mapping: {
        Pacomnm: 'bp.companyCountryId'
      },
      fixedFilters: {
        Decovst_ds: 'VIRTUAL'
      },
      restricted: true
    },

    {
      id: 263,
      key: 'OPEN_ITEMS_NAMS',
      mapping: {
        Pacomnm: 'bp.companyCountryId'
      },
      restricted: true,
      columns: [
        'Namname',
        'Pacomnm',
        'All_total',
        'Pagrpnm',
        'Mnname',
        'Decounm',
        'Detimes',
        'Preferredcommunication',
        'Open_orders',
        'Open_quotes',
        'Open_acsl_invoices',
        'Open_bp_invoices',
        'Unsubmitted_orders',
        'Unsubmitted_quotes',
        'Open_tickets',
        'Account_review_tickets',
        'Order_total',
        'Acsl_total',
        'Odlname',
        'Decovst_ds',
        'Decover',
        'Oddesk',
        'Dewatch',
        'Decompe'
      ]
    },

    {
      id: 230,
      key: 'OPERATIONAL_BPS',
      fixedFilters: {
        Deopera: 1
      },
      mapping: {
        Pacomnm: 'bp.companyCountryId'
      },
      restricted: true
    },

    {
      id: 37,
      key: 'UPCOMING_ORDER_FEES',
      fixedFilters: {
        Declodt_FROM: null,
        Declodt_TO: null,
        Ready_for_invoicing: DateType.LAST_OF_PREVIOUS_MONTH,
        Deinvty: 'LOCAL',
        Deinvok: 'not',
        Deexclp: '!=',
        Devincl: 0,
        Decurce: 'TEM'
      },
      mapping: {
        Decodid: 'pss.id',
        Decomnm: 'bp.companyCountryId'
      },
      columns: [
        {
          name: 'Avg_payment_terms', //Average Payment Terms
          aggregate: 'concat'
        },
        {
          name: 'Avg_approval_time', //Average Approval Time
          aggregate: 'concat'
        },
        {
          name: 'Thrname', //BP
          groupingSequence: 1
        },
        {
          name: 'Thlname', //BP Invoice to contact
          aggregate: 'concat'
        },
        {
          name: 'Deordnr', //Total number of orders
          label: 'Total Orders',
          aggregate: 'cnt'
        },
        {
          name: 'Ac_lacharg', //Total amount
          label: 'Total Amount',
          aggregate: 'sum'
        },
        {
          name: 'Decurce', //Currency
          aggregate: 'concat'
        },
        'Bpcustoinvnr' // BP to customer invoice number
      ],
      indicatorFn: (reportData:IReportData, ctx:IRowCountCtx) => uniqueCountIndicator(reportData, ctx, 'Thrname')
    },
    {
      browselistCode: 'QUOTE_EDIT',
      key: 'LARGE_QUOTES',
      fixedFilters: LARGE_QUOTE_KPI.fixedFilters,
      mapping: {
        Decodid_ds: 'pss.id',
        Denname: 'bp.companyCountryId'
      },
      columns: LARGE_QUOTE_KPI.columns,
      sort: LARGE_QUOTE_KPI.sort
    }
  ]
};